import React from 'react'

const ViewStockAllotment = () => {
  return (
    <div>ViewStockAllotment</div>
  )
}

export default ViewStockAllotment